import React from 'react';
import RegularText from 'modules/emergencies/components/ui/texts/RegularText';
import BodyColumn from 'modules/emergencies/components/ui/columns/bodyColumn';
import styled from 'styled-components';
import { SETTINGS } from 'modules/carriersv2/constants';
import Star from 'modules/emergencies/components/ui/icon/star';

const CustomRegularText = styled(RegularText)`
  font-size: 14px;
  text-align: left;
  color: var(--grey700);
  display: flex;
  align-items: center;
  gap: 8px;
  ${Star} {
    margin-bottom: 4px;
  }
`;

export const RatingColumn = ({ carrier }) => {
  return (
    <BodyColumn
      backgroundColor={'#FFFFFF'}
      width={SETTINGS.CARRIERS_TABLE_COLUMN_SIZES_IN_PX.RATING}
    >
      <CustomRegularText key={carrier.id}>
        {carrier.rating}
        {carrier.rating !== null && carrier.rating !== undefined && carrier.rating !== '' && (
          <Star />
        )}
      </CustomRegularText>
    </BodyColumn>
  );
};
